// Display order for tags. Walking the palette in `sorted` order (categories, and tags within each
// category) ranks every tag; sorting the tags a product/article *has* by that rank makes its pills
// follow the same order as the palette/picker. Shared by the tags store and the pill components.

type CategoryWithTags = { tags?: { id: number }[] };

export function tagOrderIndex(sorted: CategoryWithTags[]): Map<number, number> {
  const map = new Map<number, number>();
  let i = 0;
  for (const category of sorted) for (const tag of category.tags ?? []) map.set(tag.id, i++);
  return map;
}

export function sortByTagOrder<T extends { id: number }>(tags: T[], index: Map<number, number>): T[] {
  return [...tags].sort((a, b) => (index.get(a.id) ?? Infinity) - (index.get(b.id) ?? Infinity));
}
